import algoliasearch from 'algoliasearch/lite'

const index = algoliasearch('5ZFIH9CZE5', '5272d6963914b884debdd8ddf3157ba1')
    .initIndex('documentation')

/**
 * @typedef {{
 *     title: string,
 *     category: string,
 *     url: string,
 * }} DocumentationPage
 *
 * @typedef {import('@algolia/client-search').Hit<DocumentationPage>} DocumentationHit
 */

document.addEventListener('alpine:init', () => {
    Alpine.data('search', () => ({
        /** @type {boolean} */
        open: false,

        /** @type {string} */
        query: '',

        /** @type {boolean} */
        loading: false,

        /** @type {import('@algolia/client-search').SearchResponse<DocumentationPage>|null} */
        response: null,

        init() {
            let queuedQuery = null

            const search = async (query) => {
                if (this.loading) {
                    queuedQuery = query
                    return
                }

                queuedQuery = null

                this.loading = true

                this.response = await index.search(query, {
                    attributesToHighlight: ['title'],
                    highlightPreTag: '<span class="underline decoration-2 decoration-primary-400 group-hover:decoration-white group-focus:decoration-white">',
                    highlightPostTag: '</span>',
                    distinct: 5,
                })

                this.loading = false

                if (queuedQuery) {
                    await search(queuedQuery)
                }
            }

            this.$watch('query', search)

            this.$watch('open', (open) => {
                if (open) {
                    this.$nextTick(() => {
                        this.$refs.search.focus()
                    })
                }
            })
        },

        /** @returns {[string, DocumentationHit[]][]} */
        get searchResults() {
            if (!this.response || this.response.hits < 1) {
                return []
            }

            /** @type {Record<string, DocumentationHit[]>} **/
            const results = this.response.hits.reduce((grouped, hit) => {
                grouped[hit.category] ??= []
                grouped[hit.category].push(hit)

                return grouped
            }, {})

            return Object.entries(results)
        }
    }))
})